export default {"src":"/_next/static/media/cube.e99a7978.svg","height":40,"width":36};